import { SERVICE_DETAIL_URL, SERVICE_REMOVE_IMAGE_URL, SERVICE_UPDATE_IMAGE_URL, SERVICE_URL } from 'app/constants';
import { requestDelete, requestGet, requestPut } from 'app/utils/request';
import { HttpStatusCode } from 'axios';
const get = async (params) => {
    const res = await requestGet(SERVICE_DETAIL_URL, { params }); // call api get data
    // get status and data from response
    const { status, data } = res;
    if (status === HttpStatusCode.Ok) {
        // return search data
        return data.payload;
    } else {
        return {
            data: []
        };
    }
};
/* Request to create user data from server
 * @param {Object} data store user management data
 */
const update = (data) => requestPut(SERVICE_URL, data);
/* Request to create user data from server
 * @param {Object} data store user management data
 */
const updateImg = (data) => requestPut(SERVICE_UPDATE_IMAGE_URL, data);
/* Request to create user data from server
 * @param {Object} data store user management data
 */
const removeImage = (data) => requestDelete(SERVICE_REMOVE_IMAGE_URL, { data });
export default { update, get, removeImage, updateImg };
